import { v4 as uuid } from "uuid";
import { boolean, date, number, object, string, ObjectSchema } from "yup";

import type { Address, Client, Salutation } from "@/types";

export const addressSchema: ObjectSchema<Address> = object({
  street: string().label("Street").ensure(),
  zipcode: string().label("Zipcode").ensure(),
  city: string().label("City").ensure(),
  lat: number().label("Latitude").optional(),
  lng: number().label("Longitude").optional(),
  manuallyPositioned: boolean().optional(),
});

export const clientSchema: ObjectSchema<Client> = object({
  _id: string()
    .uuid()
    .required()
    .default(() => uuid()),
  _rev: string().optional(),
  _deleted: boolean().optional(),
  type: string().ensure().required().oneOf(["client"]).default("client"),
  createdAt: date().optional(),
  updatedAt: date().optional(),
  salutation: string<Salutation>()
    .label("Salutation")
    .ensure()
    .oneOf(["", "mr", "ms"]),
  firstname: string().label("Firstname").ensure().required().min(2),
  lastname: string().label("Lastname").ensure().required().min(2),
  phone: string().label("Phone").ensure(),
  email: string().label("E-Mail").ensure().email(),
  address: addressSchema.default(() => addressSchema.getDefault()),
  notes: string().label("Notes").ensure(),
  active: boolean().default(true),
});
